// imports react
import React from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

//imports components
import styles from "../styles/evokchat.module.css";

export function UserInfoProfile({ userData, darkMode, onEditProfile }) {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year}`;
  };


  return (
    <div className="card mb-5 mb-xl-10" id="kt_profile_details_view" data-bs-theme={darkMode ? ('dark') : ('light')}>
      <div className="card-header cursor-pointer">
        <div className="card-title m-0">
          <h3 className="fw-bold m-0">Detalhes do Perfil</h3>
        </div>

        <p
          onClick={onEditProfile}
          className="btn btn-sm btn-primary align-self-center mt-6"
        >
          Editar Perfil
        </p>
      </div>

      <div className="card-body p-9">
        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">Nome Completo</label>

          <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{userData.nome}</span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">Email</label>

          <div className="col-lg-8 fv-row">
            <span className="fw-semibold text-gray-800 fs-6">{userData.email}</span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">
            Celular
            <span
              className="ms-1"
              data-bs-toggle="tooltip"
              title="Phone number must be active"
            >
              <i className="ki-outline ki-information fs-7"></i>
            </span>
          </label>

          <div className="col-lg-8 d-flex align-items-center">
            <span className="fs-6 text-gray-800 me-2">
              {userData.celular}
            </span>
            <span className="badge badge-success">Verificado</span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">Data de Nascimento</label>

          <div className="col-lg-8 fv-row">
            <span className="fw-semibold text-gray-800 fs-6">{formatDate(userData.data_nasc)}</span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">Idade</label>

          <div className="col-lg-8 fv-row">
            <span className="fw-semibold text-gray-800 fs-6">{userData.idade}</span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-4 fw-semibold text-muted">
            Comunicação
          </label>

          <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">Email, Celular</span>
          </div>
        </div>
      </div>
    </div>
  );
}
